import React from 'react';
import './DoctorPerfil.css';
import drMichael from '../assets/images/dr-michael.png';
import logoUA from '../assets/images/logo-ua.png';
import logoUChile from '../assets/images/logo-uchile.png';
import logoZimmer from '../assets/images/logo-zimmer.png';
import logoUcam from '../assets/images/logo-ucam.png';

const DoctorMichael = () => {
  return (
    <div className="doctor-perfil">
      <div className="container">
        <div className="perfil-header">
          <div className="perfil-info">
            <div className="perfil-imagen">
              <img src={drMichael} alt="Dr. Michael Arancibia" />
            </div>
            <div className="perfil-datos-container">
              <div className="perfil-datos">
                <h1>Dr. Michael Arancibia</h1>
                <p className="experiencia">11 años de experiencia</p>
                <p className="registro">N° reg. 387383</p>
              </div>
              <div className="formacion-lista">
                <div className="formacion-item">
                  <img src={logoUA} alt="UA" />
                  <div className="formacion-texto">
                    <p>Cirujano Dentista</p>
                    <p>- Univ. Antofagasta (2015)</p>
                  </div>
                </div>
                <div className="formacion-item">
                  <img src={logoUChile} alt="Universidad de Chile" />
                  <div className="formacion-texto">
                    <p>Especialista en Implantología</p>
                    <p>Buco Maxilofacial</p>
                    <p>- Univ. Chile (2019)</p>
                  </div>
                </div>
                <div className="formacion-item">
                  <img src={logoUA} alt="UA" />
                  <div className="formacion-texto">
                    <p>Instructor clínico Cátedra Cirugía Oral</p>
                    <p>- Univ. Antofagasta (2014-2018)</p>
                  </div>
                </div>
                <div className="formacion-item">
                  <img src={logoZimmer} alt="Zimmer" />
                  <div className="formacion-texto">
                    <p>Postitulo Instituto Zimmer</p>
                    <p>- Miami, USA (2024)</p>
                  </div>
                </div>
                <div className="formacion-item">
                  <img src={logoUcam} alt="UCAM" />
                  <div className="formacion-texto">
                    <p>Postitulo "Paciente Virtual Dinámico"</p>
                    <p>- UCAM España (2025)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorMichael; 